"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioTile = void 0;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../types/common");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Card = require("../Card");
var _Chip = require("../Chip");
var _Icon = require("../Icon");
var _RadioButton = require("../RadioButton");
var _Text = require("../Text");
var _RadioTileModule = _interopRequireDefault(require("./RadioTile.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const RadioTile = exports.RadioTile = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    id,
    semantic = _common.ALERT_SEMANTIC.neutral,
    header,
    description,
    chipItems,
    iconName,
    // @ts-ignore - TS2322 - Type 'string' is not assignable to type '"large" | "medium" | "small"'.
    iconSize = _Icon.ICON_SIZE.medium,
    // @ts-ignore - TS2322 - Type 'string' is not assignable to type '"regular" | "solid" | "duotone" | "brands"'.
    iconType = _Icon.ICON_TYPE.solid,
    onTileClick,
    isSelected = false,
    ...props
  } = _ref;
  const handleTileClick = e => {
    onTileClick && onTileClick(e, id);
  };
  return /*#__PURE__*/React.createElement(_Card.ClickableCard, _extends({}, props, {
    ref: ref,
    "data-testid": "RadioTile",
    classNames: {
      wrapper: (0, _classify.default)(_RadioTileModule.default.wrapper, classNames?.wrapper)
    },
    onClick: handleTileClick
  }), /*#__PURE__*/React.createElement("div", {
    className: _RadioTileModule.default.iconContainer
  }, !!iconName && /*#__PURE__*/React.createElement(_Icon.SemanticIcon, {
    semantic: semantic,
    name: iconName,
    size: iconSize,
    type: iconType
  })), /*#__PURE__*/React.createElement("div", {
    className: _RadioTileModule.default.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: _RadioTileModule.default.textContainer
  }, !!header && /*#__PURE__*/React.createElement(_Text.SubTitleMedium, null, header), !!description && /*#__PURE__*/React.createElement(_Text.BodyMedium, {
    color: "secondary"
  }, description)), !!chipItems?.length && /*#__PURE__*/React.createElement("div", {
    className: _RadioTileModule.default.chipsContainer
  }, chipItems.map((item, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(_Chip.Chip, {
    key: index,
    semantic: "primary"
  }, item)))), /*#__PURE__*/React.createElement("div", {
    className: _RadioTileModule.default.btnContainer
  }, /*#__PURE__*/React.createElement(_RadioButton.RadioButton, {
    classNames: {
      wrapper: _RadioTileModule.default.radioButtonWrapper
    },
    value: id,
    selectedValue: isSelected ? id : '',
    tabIndex: -1
  })));
});